import {Resource} from '@raison/types';
import React from 'react';
import {useSelector} from 'react-redux';
import {Navigate} from 'react-router';
import {RsnTabs} from '~/library/ui-kit';
import {groupBy} from '~/processes/dashboard/CurrencySelectionPage/utils';
import {AccountsGroupedByProvider} from '~/processes/dashboard/components/AccountsGroupedByProvider';
import ListLayout from '~/shared/layouts/ListLayout/ListLayout';
import {useAppDispatch} from '~/shared/store';
import {For, Layout, LayoutProps, LoadingScreen, Option, renderEmptyTab} from './components';
import {CurrencyOptionView} from './interfaces';

interface ReceivePageProps extends LayoutProps {
    selectOperations: (state: AppModel) => Resource<CurrencyOptionView[]>;
}

export function ReceiveCurrencySelectionPage({selectOperations: selectOptions, ...props}: ReceivePageProps) {
    const resource = useSelector(selectOptions);
    const dispatch = useAppDispatch();

    if (!resource.isSuccess) {
        return <LoadingScreen {...props} />;
    }

    const options = resource.data;
    if (options.length === 0) {
        return <Navigate replace to='/assets' />;
    }

    const {fiat, crypto, stablecoin} = groupBy(options, option => option.accountType);

    return (
        <Layout {...props}>
            <RsnTabs
                tabs={[
                    {
                        label: 'Top up',
                        element: <AccountsGroupedByProvider data={fiat ?? []} />,
                    },
                    {
                        label: 'Receive',
                        element: (
                            <ListLayout>
                                <For each={[...(crypto ?? []), ...(stablecoin ?? [])]} empty={renderEmptyTab()}>
                                    {op => (
                                        <Option key={op.shortName} {...op} onClick={() => dispatch(op.clickAction)} />
                                    )}
                                </For>
                            </ListLayout>
                        ),
                    },
                ]}
            >
                <div className='p-4'>
                    <RsnTabs.Triggers />
                </div>
                <RsnTabs.Content />
            </RsnTabs>
        </Layout>
    );
}
